var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-4"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Requests')))])]),_c('b-container',{attrs:{"fluid":""}},[_c('base-grid',{attrs:{"callback":_vm.fetchRequests,"fields":_vm.fields,"default-sort-field":"createdAt"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }